import React, { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useForm, setValue } from "react-hook-form";
import { checkAccess } from '../../../actions/securityactions'
import * as actions from '../actions/secmasteractions'
import NavBar from '../../../components/NavBar';
import SideNav from '../../../components/SideNav';
import DashboardTitle from '../../../components/DashboardTitle';
import Footer from '../../../components/Footer';
import CustomPager from '../../../components/custompager';
import LeftSideMenu from '../../../components/newdashboardcomponent/LeftSideMenu';
import TopBar from '../../../components/newdashboardcomponent/TopBar';


export default function PasswordProfile() {

    const state = useSelector(state => state.secmasterReducer);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    let checkPermissions = state.checkPermissions;
    let passwordProfile = state.passwordProfile;
    let passwordProfileListing = state.passwordProfileListing;
    console.log("listing", passwordProfileListing.searchResult)

    useEffect(() => {
        let valuesToMap = [
            { "passwordProfileId": passwordProfile.passwordProfileId },
            { "profileName": passwordProfile.profileName },
            { "minimumLength": passwordProfile.minimumLength },
            { "passwordAgeInDays": passwordProfile.passwordAgeInDays },
            { "specialCharNotAllowed": passwordProfile.specialCharNotAllowed },
            { "maximumLength": passwordProfile.maximumLength },
            { "remainderDaysBeforeExp": passwordProfile.remainderDaysBeforeExp },
            { "passwordHistory": passwordProfile.passwordHistory },
            { "loginFailCount": passwordProfile.loginFailCount },
            { "passwordResetYN": passwordProfile.passwordResetYN },
            { "splCharMandatoryYN": passwordProfile.splCharMandatoryYN },
            { "atLeastOneUpperCase": passwordProfile.atLeastOneUpperCase },
            { "atLeastOneLowerCase": passwordProfile.atLeastOneLowerCase },
            { "atLeastOneNumber": passwordProfile.atLeastOneNumber },
            { "matchCharAtSamePosition": passwordProfile.matchCharAtSamePosition },
            { "matchCharCount": passwordProfile.matchCharCount },
            { "matchCharAtAnyPosition": passwordProfile.matchCharAtAnyPosition },
            { "resetFailCountOnLogin": passwordProfile.resetFailCountOnLogin },
            { "resetFailCountDaily": passwordProfile.resetFailCountDaily },
            { "captchaRequired": passwordProfile.captchaRequired },
            { "logonBannerYN": passwordProfile.logonBannerYN },
        ];
        valuesToMap.forEach(i => Object.keys(i).forEach(key => setPasswordProfileValue(key, i[key])));
    }, [passwordProfile]);

    useEffect(() => {
        async function CheckPermissions() {
            await dispatch(checkAccess({ pageMenuId: 737 }));
            await dispatch(actions.checkSecurityModuleAccess());
        }
        CheckPermissions();
        dispatch(actions.getAllPasswordProfiles(1));
    }, []);

    const { register: registerPasswordProfile, handleSubmit: handlePasswordProfile,
        reset: resetPasswordProfile, getFieldState, setValue: setPasswordProfileValue, watch: watchPolicyInformation, formState: { errors: errorsPasswordProfile } } = useForm();

    const { register: registerPasswordProfileListing, handleSubmit: handlePasswordProfileListing,
        formState: { errors: errorsPasswordProfileListing } } = useForm();


    // const handlePasswordProfile = (e) => {}

    const onAddNewPasswordProfile = async () => {
        onResetPasswordProfile();
    }

    const onPageChangeRequest = async (page) => {
        await dispatch(actions.getAllPasswordProfiles(page))
    }
    const onUpdateNewPasswordProfileProfile = async (e) => {
        let { name, value } = e.target;
        dispatch(actions.updatePasswordProfileProfile({ name, value }));
        console.log("passwordProfile", passwordProfile)
    }
    const onUpdateNewPasswordProfileProfileCheckBoxes = async (e) => {
        let { name, checked } = e.target;
        let value = checked;
        dispatch(actions.updatePasswordProfileProfile({ name, value }));
        console.log("passwordProfile", passwordProfile)
    }
    const onError = (errorsPasswordProfile, e) => console.log(errorsPasswordProfile, e);

    const onCollapseSearch = () => {
        if (passwordProfile.searchClass === "collapse show") {
            //    dispatch(actions.collapseSearch(true));
        } else {
            //   dispatch(actions.collapseSearch(false));
        }
    }


    const onPasswordProfileSubmit = async (data, e) => {

        //await dispatch(actions.getAllPasswordProfiles());
        /* let currentpasswordProfileId = */await dispatch(actions.savePasswordProfile());
        //dispatch(actions.goToMemberInformation(true));
        //navigate('?passwordProfileId=' + currentpasswordProfileId);

    }

    const onResetPasswordProfile = () => {
        navigate('');
        resetPasswordProfile();
        dispatch(actions.clearPasswordProfileParams());

    }

    const onDisplayPasswordProfile = async (passwordProfileId) => {



        await dispatch(actions.getAllPasswordProfilesByProfileId(passwordProfileId));
    }



    const updateSortString = async (val) => {
    }

    const onErrorsPasswordProfile = (errorsMemberInformation, e) => { console.log(errorsMemberInformation, e) }


    function renderPasswordProfile() {

        let PasswordProfileId = <input className={errorsPasswordProfile.userCode ? 'form-control is-invalid' : 'form-control fw-bold'}
            id="passwordProfileId" required=""
            placeholder="--Password Profile ID--"
            name='passwordProfileId'
            {...registerPasswordProfile("passwordProfileId", { onChange: (value) => onUpdateNewPasswordProfileProfile(value) })}
            value={passwordProfile.passwordProfileId}
        />

        let ProfileName = <input className="form-control fw-bold"
            placeholder="--Profile Name--"
            id="profileName"
            name="profileName"
            {...registerPasswordProfile("profileName", { onChange: (value) => onUpdateNewPasswordProfileProfile(value) })}
            value={passwordProfile.profileName}
        />

        let SpecialCharNotAllowed = <input className="form-control fw-bold"
            placeholder="--Special Char Not Allowed--"
            id="specialCharNotAllowed"
            name="specialCharNotAllowed"
            {...registerPasswordProfile("specialCharNotAllowed", { onChange: (value) => onUpdateNewPasswordProfileProfile(value) })}
            value={passwordProfile.specialCharNotAllowed}
        />

        let MinimumLength = <input className='form-control fw-bold'
            type="text" id="minimumLength"
            placeholder="Minimum Length"
            name='minimumLength'
            {...registerPasswordProfile("minimumLength", { onChange: (value) => onUpdateNewPasswordProfileProfile(value) })}
            value={passwordProfile.minimumLength}
        />

        let MaximumLength = <input className='form-control fw-bold'
            type="text" id="maximumLength"
            placeholder="Maximum Length"
            name='maximumLength'
            {...registerPasswordProfile("maximumLength", { onChange: (value) => onUpdateNewPasswordProfileProfile(value) })}
            value={passwordProfile.maximumLength}
        />

        let PasswordAgeInDays = <input className='form-control fw-bold'
            type="text" id="passwordAgeInDays"
            placeholder="Password Age In Days"
            name='passwordAgeInDays'
            {...registerPasswordProfile("passwordAgeInDays", { onChange: (value) => onUpdateNewPasswordProfileProfile(value) })}
            value={passwordProfile.passwordAgeInDays}
        />

        let RemainderDaysBeforeExp = <input className='form-control fw-bold'
            type="text" id="remainderDaysBeforeExp"
            placeholder="Remainder Days Before Exp "
            name='remainderDaysBeforeExp'
            {...registerPasswordProfile("remainderDaysBeforeExp", { onChange: (value) => onUpdateNewPasswordProfileProfile(value) })}
            value={passwordProfile.remainderDaysBeforeExp}
        />

        let PasswordHistory = <input className='form-control fw-bold'
            type="text" id="passwordHistory"
            placeholder="Password History"
            name='passwordHistory'
            {...registerPasswordProfile("passwordHistory", { onChange: (value) => onUpdateNewPasswordProfileProfile(value) })}
            value={passwordProfile.passwordHistory}
        />

        let LoginFailCount = <input className='form-control fw-bold'
            type="text" id="loginFailCount"
            placeholder="Login Fail Count"
            name='loginFailCount'
            {...registerPasswordProfile("loginFailCount", { onChange: (value) => onUpdateNewPasswordProfileProfile(value) })}
            value={passwordProfile.loginFailCount}
        />

        let MatchCharCount = <input className='form-control fw-bold'
            type="text" id="matchCharCount"
            placeholder="Match Char Count"
            name='matchCharCount'
            {...registerPasswordProfile("matchCharCount", { onChange: (value) => onUpdateNewPasswordProfileProfile(value) })}
            value={passwordProfile.matchCharCount}
        />

        let PasswordResetYN = <div className="form-check" id="Check1">
            <input type="checkbox" id={passwordProfile.passwordResetYN} className="form-check-input" name="passwordResetYN"
                checked={passwordProfile.passwordResetYN == true ? true : false}
                {...registerPasswordProfile("passwordResetYN", { onChange: (value) => onUpdateNewPasswordProfileProfileCheckBoxes(value) })}
                value={passwordProfile.passwordResetYN} />
        </div>

        let SplCharMandatoryYN = <div className="form-check" id="Check1">
            <input type="checkbox" id={passwordProfile.splCharMandatoryYN} className="form-check-input" name="splCharMandatoryYN"
                checked={passwordProfile.splCharMandatoryYN == true ? true : false}
                {...registerPasswordProfile("splCharMandatoryYN", { onChange: (value) => onUpdateNewPasswordProfileProfileCheckBoxes(value) })}
                value={passwordProfile.splCharMandatoryYN} />


        </div>

        let AtLeastOneUpperCase = <div className="form-check" id="Check1">
            <input type="checkbox" id={passwordProfile.atLeastOneUpperCase} className="form-check-input" name="atLeastOneUpperCase"
                checked={passwordProfile.atLeastOneUpperCase == true ? true : false}
                {...registerPasswordProfile("atLeastOneUpperCase", { onChange: (value) => onUpdateNewPasswordProfileProfileCheckBoxes(value) })}
                value={passwordProfile.atLeastOneUpperCase} />
        </div>

        let AtLeastOneLowerCase = <div className="form-check" id="Check1">
            <input type="checkbox" id={passwordProfile.atLeastOneLowerCase} className="form-check-input" name="atLeastOneLowerCase"
                checked={passwordProfile.atLeastOneLowerCase == true ? true : false}
                {...registerPasswordProfile("atLeastOneLowerCase", { onChange: (value) => onUpdateNewPasswordProfileProfileCheckBoxes(value) })}
                value={passwordProfile.atLeastOneLowerCase} />
        </div>

        let AtLeastOneNumber = <div className="form-check" id="Check1">
            <input type="checkbox" id={passwordProfile.atLeastOneNumber} className="form-check-input" name="atLeastOneNumber"
                checked={passwordProfile.atLeastOneNumber == true ? true : false}
                {...registerPasswordProfile("atLeastOneNumber", { onChange: (value) => onUpdateNewPasswordProfileProfileCheckBoxes(value) })}
                value={passwordProfile.atLeastOneNumber} />
        </div>

        let MatchCharAtSamePosition = <div className="form-check" id="Check1">
            <input type="checkbox" id={passwordProfile.matchCharAtSamePosition} className="form-check-input" name="matchCharAtSamePosition"
                checked={passwordProfile.matchCharAtSamePosition == true ? true : false}
                {...registerPasswordProfile("matchCharAtSamePosition", { onChange: (value) => onUpdateNewPasswordProfileProfileCheckBoxes(value) })}
                value={passwordProfile.matchCharAtSamePosition} />
        </div>


        let MatchCharAtAnyPosition = <div className="form-check" id="Check1">
            <input type="checkbox" id={passwordProfile.matchCharAtAnyPosition} className="form-check-input" name="matchCharAtAnyPosition"
                checked={passwordProfile.matchCharAtAnyPosition == true ? true : false}
                {...registerPasswordProfile("matchCharAtAnyPosition", { onChange: (value) => onUpdateNewPasswordProfileProfileCheckBoxes(value) })}
                value={passwordProfile.matchCharAtAnyPosition} />
        </div>

        let ResetFailCountOnLogin = <div className="form-check" id="Check1">
            <input type="checkbox" id={passwordProfile.resetFailCountOnLogin} className="form-check-input" name="resetFailCountOnLogin"
                checked={passwordProfile.resetFailCountOnLogin == true ? true : false}
                {...registerPasswordProfile("resetFailCountOnLogin", { onChange: (value) => onUpdateNewPasswordProfileProfileCheckBoxes(value) })}
                value={passwordProfile.resetFailCountOnLogin} />
        </div>

        let ResetFailCountDaily = <div className="form-check" id="Check1">
            <input type="checkbox" id={passwordProfile.resetFailCountDaily} className="form-check-input" name="resetFailCountDaily"
                checked={passwordProfile.resetFailCountDaily == true ? true : false}
                {...registerPasswordProfile("resetFailCountDaily", { onChange: (value) => onUpdateNewPasswordProfileProfileCheckBoxes(value) })}
                value={passwordProfile.resetFailCountDaily} />
        </div>

        let CaptchaRequired = <div className="form-check" id="Check1">
            <input type="checkbox" id={passwordProfile.captchaRequired} className="form-check-input" name="captchaRequired"
                checked={passwordProfile.captchaRequired == true ? true : false}
                {...registerPasswordProfile("captchaRequired", { onChange: (value) => onUpdateNewPasswordProfileProfileCheckBoxes(value) })}
                value={passwordProfile.captchaRequired} />
        </div>

        let LogonBannerYN = <div className="form-check" id="Check1">
            <input type="checkbox" id={passwordProfile.logonBannerYN} className="form-check-input" name="logonBannerYN"
                checked={passwordProfile.logonBannerYN == true ? true : false}
                {...registerPasswordProfile("logonBannerYN", { onChange: (value) => onUpdateNewPasswordProfileProfileCheckBoxes(value) })}
                value={passwordProfile.logonBannerYN} />
        </div>

        return (
            <>
                <ul className="nav nav-tabs nav-bordered mb-1">
                </ul>
                <form className="form-group needs-validation collapse show" id="CollapseQuoteInformation"
                    onSubmit={handlePasswordProfile(onPasswordProfileSubmit, onErrorsPasswordProfile)} noValidate="noValidate">
                    <div className="row g-2">
                        <div className="mb-1 col-md-12">
                            <div className="btn-group float-end" id="tooltip-container2">
                                <div class="btn-group" role="group" aria-label="Second group">
                                    {checkPermissions.hasResetPasswordProfile && <button type="button" className="btn btn-danger"
                                        data-bs-container="#tooltip-container2" data-bs-toggle="tooltip" data-bs-placement="bottom" title="Reset" onClick={() => onResetPasswordProfile()}> Reset <i className="mdi mdi-rotate-left"></i></button>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row g-2">
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Password Profile ID </label>
                            {PasswordProfileId}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Profile Name </label>
                            {ProfileName}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Minimum Length </label>
                            {MinimumLength}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Maximum Length </label>
                            {MaximumLength}
                        </div>
                    </div>

                    <div className="row g-2">
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Password Age InDays </label>
                            {PasswordAgeInDays}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Remainder Days Before Exp </label>
                            {RemainderDaysBeforeExp}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Password History </label>
                            {PasswordHistory}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Login Fail Count </label>
                            {LoginFailCount}
                        </div>
                    </div>

                    <div className="row g-2">
                        <div className="mb-3 col-md-3">
                            <label class="form-label" for="customSwitch1" > Password Reset Y/N </label>
                            {PasswordResetYN}
                        </div>

                        <div className="mb-3 col-md-3">
                            <label class="form-label" for="customSwitch1"> Spl Char Mandatory Y/N </label>
                            {SplCharMandatoryYN}
                        </div>

                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Special Char Not Allowed </label>
                            {SpecialCharNotAllowed}
                        </div>

                        <div className="mb-3 col-md-3">
                            <label class="form-label" for="customSwitch1"> At Least One UpperCase </label>
                            {AtLeastOneUpperCase}
                        </div>
                    </div>

                    <div className="row g-2">
                        <div className="mb-3 col-md-3">
                            <label class="form-label" for="customSwitch1" > At Least One LowerCase </label>
                            {AtLeastOneLowerCase}
                        </div>

                        <div className="mb-3 col-md-3">
                            <label class="form-label" for="customSwitch1"> At Least One Number</label>
                            {AtLeastOneNumber}
                        </div>

                        <div className="mb-3 col-md-3">
                            <label class="form-label" for="customSwitch1"> Match Char At Same Position </label>
                            {MatchCharAtSamePosition}
                        </div>

                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Match Char Count </label>
                            {MatchCharCount}
                        </div>
                    </div>

                    <div className="row g-2">
                        <div className="mb-3 col-md-3">
                            <label class="form-label" for="customSwitch1" > Match Char At Any Position </label>
                            {MatchCharAtAnyPosition}
                        </div>

                        <div className="mb-3 col-md-3">
                            <label class="form-label" for="customSwitch1"> Reset Fail Count On Login </label>
                            {ResetFailCountOnLogin}
                        </div>

                        <div className="mb-3 col-md-3">
                            <label class="form-label" for="customSwitch1"> Reset Fail Count Daily </label>
                            {ResetFailCountDaily}
                        </div>

                        <div className="mb-3 col-md-3">
                            <label class="form-label" for="customSwitch1"> Captcha Required </label>
                            {CaptchaRequired}
                        </div>
                    </div>

                    <div className="row g-2">
                        <div className="mb-3 col-md-3">
                            <label class="form-label" for="customSwitch1" > Logon Banner Y/N </label>
                            {LogonBannerYN}
                        </div>
                    </div>

                    {/* <div className="row g-2">
                        <div className="mb-3 col-md-3">
                            <button type="button" className="btn btn-primary float-start" data-bs-container="#tooltip-container2"
                                data-bs-toggle="tooltip" data-bs-placement="bottom" title="More" onClick={() => onAddNewPasswordProfile()}>
                                <i className="dripicons-plus"></i> More
                            </button>
                        </div>
                    </div> */}

                    <div className="row g-2">
                        <div className="mb-4 col-md-6">
                            <div id="tooltip-container2">
                                {checkPermissions.hasSavePasswordProfile && <button type="submit" className="btn btn-success float-end"
                                    data-bs-container="#tooltip-container2" data-bs-toggle="tooltip" data-bs-placement="bottom" title="Save" ><i className="mdi mdi-content-save"></i> Save   </button>
                                }
                            </div>
                        </div>

                        {/* <div className="mb-4 col-md-4">
                            <div id="tooltip-container2">
                                <button type="submit" className="btn btn-danger float-end"
                                    data-bs-container="#tooltip-container2" data-bs-toggle="tooltip" data-bs-placement="bottom" title="Cancel" > Cancel   </button>
                            </div>
                        </div> */}
                    </div>


                </form>

            </>
        )

    }

    function renderPasswordProfileListing() {

        return (
            <>
                <ul className="nav nav-tabs nav-bordered mb-1">
                </ul>
                <div>
                    {passwordProfileListing.showSearchResult &&
                        <>
                            <div className="table-responsive">
                                <table id="scroll-horizontal-datatable" className="table w-100 nowrap resizeable_table_head">
                                    <thead>
                                        <tr>
                                            <th onClick={() => updateSortString('Actions')}>Actions ⬇️ </th>
                                            <th onClick={() => updateSortString('PasswordProfileId')}>Password Profile ID ⬇️ </th>
                                            <th onClick={() => updateSortString('ProfileName')}>Name ⬇️</th>
                                            <th onClick={() => updateSortString('PasswordAgeInDays')}>Age In Days ⬇️</th>
                                            <th onClick={() => updateSortString('MinimumLength')}>Minimum Length ⬇️</th>
                                            <th onClick={() => updateSortString('SpecialCharNotAllowed')}> Special Char Not Allowed ⬇️</th>
                                            <th onClick={() => updateSortString('MaximumLength')}>Maximum Length ⬇️</th>
                                            <th onClick={() => updateSortString('RemainderDaysBeforeExpiry')}>Remainder Days Before Expiry ⬇️</th>
                                            <th onClick={() => updateSortString('PasswordHistory')}>Password History ⬇️</th>
                                            <th onClick={() => updateSortString('LoginFailCount')}>Login Fail Count ⬇️</th>
                                            <th onClick={() => updateSortString('ResetPasswordYn')}>Reset Password Yn ⬇️</th>
                                            <th onClick={() => updateSortString('SplCharMandatoryYn')}>Spl Char Mandatory Yn ⬇️</th>
                                            <th onClick={() => updateSortString('OneUpperCaseYn')}>One Upper Case Yn ⬇️</th>
                                            <th onClick={() => updateSortString('OneLowerCaseYn')}>One Lower Case Yn ⬇️</th>
                                            <th onClick={() => updateSortString('OneNumberYn')}>One Number Yn ⬇️</th>
                                            <th onClick={() => updateSortString('MatchCharSamePositionYn')}>Match Char Same Position Yn ⬇️</th>
                                            <th onClick={() => updateSortString('MatchCharCount')}>Match Char Count ⬇️</th>
                                            <th onClick={() => updateSortString('MatchCharAtAnyPostYn')}>Match Char At Any PostYn ⬇️</th>
                                            <th onClick={() => updateSortString('ResetFailCount')}>Reset Fail Count ⬇️</th>
                                            <th onClick={() => updateSortString('DailyResetFailCount')}>Daily Reset Fail Count ⬇️</th>
                                            <th onClick={() => updateSortString('CaptchaYn')}>Captcha Yn ⬇️</th>
                                            <th onClick={() => updateSortString('LogonBannerYn')}>Logon Banner Yn ⬇️</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {

                                            passwordProfileListing.searchResult.result.length > 0 && passwordProfileListing.searchResult.result.map((searchResult, index) => (

                                                <tr >
                                                    <td onClick={() => onDisplayPasswordProfile(searchResult.passwordProfileId)}>
                                                        {checkPermissions.hasViewPasswordProfile && <button type="button" className="btn btn-secondary btn-sm" data-bs-container="#tooltip-container2"
                                                            data-bs-toggle="tooltip" data-bs-placement="bottom" title="View" >
                                                            <i className="dripicons-preview"></i>
                                                        </button>
                                                        }
                                                    </td>
                                                    <td> {searchResult.passwordProfileId} </td>
                                                    <td> {searchResult.profileName} </td>
                                                    <td> {searchResult.passwordAge} </td>
                                                    <td> {searchResult.minimumLength} </td>
                                                    <td> {searchResult.specialCharNotAllowed} </td>
                                                    <td> {searchResult.maximumLength} </td>
                                                    <td> {searchResult.remainderDaysBeforeExpiry} </td>
                                                    <td> {searchResult.passwordHistory} </td>
                                                    <td> {searchResult.loginFailCount} </td>
                                                    <td> {searchResult.resetPasswordYn} </td>
                                                    <td> {searchResult.splCharMandatoryYn} </td>
                                                    <td> {searchResult.oneUpperCaseYn} </td>
                                                    <td> {searchResult.oneLowerCaseYn} </td>
                                                    <td> {searchResult.oneNumberYn} </td>
                                                    <td> {searchResult.matchCharSamePositionYn} </td>
                                                    <td> {searchResult.matchCharCount} </td>
                                                    <td> {searchResult.matchCharAtAnyPostYn} </td>
                                                    <td> {searchResult.resetFailCount} </td>
                                                    <td> {searchResult.dailyResetFailCount} </td>
                                                    <td> {searchResult.captchaYn} </td>
                                                    <td> {searchResult.logonBannerYn} </td>

                                                </tr>

                                            ))
                                        }

                                    </tbody>
                                </table>
                            </div>
                        </>}
                    < div className="float-end">
                        <CustomPager onPageChangeRequest={onPageChangeRequest} pagedResult={passwordProfileListing.searchResult} />
                    </div>

                </div >



            </>
        )

    }


    return (

        <>
            <div className="wrapper">
                <LeftSideMenu />
                <div class="content-page">

                    <TopBar />
                    <div class="content">
                        <DashboardTitle />
                        {<div className="content">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card ribbon-box">
                                        <div className="card-body">
                                            <div className="ribbon ribbon-primary float-start"><i className="dripicons-list me-1"></i>Password Profile</div>
                                            <div className="btn-group float-end" id="tooltip-container2">

                                                {/* {
                                                        <button type="button" className="btn btn-success" data-bs-container="#tooltip-container2"
                                                            data-bs-toggle="tooltip" data-bs-placement="bottom" title="Add New User" onClick={() => onAddNewPasswordProfile()}>
                                                            <i className="dripicons-plus"></i> Add
                                                        </button>
                                                    }
                                                    {
                                                        <button type="button" className="btn btn-success" data-bs-container="#tooltip-container2"
                                                            data-bs-toggle="tooltip" data-bs-placement="bottom" title="Add New User" onClick={() => onAddNewPasswordProfile()}>
                                                            Back
                                                        </button>
                                                    } */}


                                                <button className="btn btn-sm btn-light ms-1 btn-sm" type="button" id="searchcollapsableButton"
                                                    data-bs-toggle="collapse" data-bs-target="#CollapseSearchComponents"
                                                    aria-expanded="false" aria-controls="CollapseSearchComponents" onClick={() => onCollapseSearch()}>
                                                    <i className="mdi mdi-arrow-up-down"></i>
                                                </button>
                                            </div>
                                            <h5 className="text-primary float-end mt-0"> </h5>
                                            <div className="ribbon-content">
                                                {renderPasswordProfile()}
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>}

                        {<div className="content">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card ribbon-box">
                                        <div className="card-body">
                                            <div className="ribbon ribbon-success float-start"><i className="dripicons-list me-1"></i> Password Profile Listing</div>
                                            <div className="btn-group float-end" id="tooltip-container2">
                                                {/* {
                                                        <button type="button" className="btn btn-success" data-bs-container="#tooltip-container2"
                                                            data-bs-toggle="tooltip" data-bs-placement="bottom" title="Add New User" onClick={() => onAddNewPasswordProfile()}>
                                                            <i className="dripicons-plus"></i> Add
                                                        </button>
                                                    } */}
                                                <button className="btn btn-sm btn-light ms-1 btn-sm" type="button" id="searchcollapsableButton"
                                                    data-bs-toggle="collapse" data-bs-target="#CollapseSearchComponents"
                                                    aria-expanded="false" aria-controls="CollapseSearchComponents" onClick={() => onCollapseSearch()}>
                                                    <i className="mdi mdi-arrow-up-down"></i>
                                                </button>
                                            </div>
                                            <h5 className="text-primary float-end mt-0"> </h5>
                                            <div className="ribbon-content">
                                                {renderPasswordProfileListing()}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>}

                    </div>
                    <Footer />
                </div>

            </div>

        </>
    )
}
